// Copyright (c) 2016 Deere & Company

import OpenPipsSummary from '@deere/cps-it.warranty-model-factory/lib/open-pips-summary';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateOpenPipsSummary = (state, action) =>
    OpenPipsSummary.update(state, {
        $set: action.data
    });

export default (state = getDefaultState().openPipsSummary, action) => {

    const actionTypes = {
        [actions.READ_OPEN_PIP_PRODUCTS_SUMMARY_SUCCESS]: updateOpenPipsSummary
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/pip/open-pips/reducers/open-pips-summary.js